import { createContext } from 'react';
import type { PhotoDraftStore } from './photo-draft-types';

export const PhotoDraftContext = createContext<PhotoDraftStore | null>(null);
